'use strict';

import $ from 'jquery';
import Swal from 'sweetalert2';
import { recaptchaUpdater } from '../../modules/recaptcha';

const appAccessCode = {
  bindActions() {
    $('.o-btn--access-code').on('click', e => {
      e.preventDefault();

      var post = {};

      post.cpf = $('input[name="cpf"]').val();
      post._token = $('meta[name="csrf-token"]').attr('content');

      var url = '/entrar/codigo-de-acesso';

      $.ajax({
        type: 'POST',
        url: url,
        data: post,
        dataType: 'json',
        success: function (data) {
          if (data.success) {
            $('#send-block').removeClass('u-display--none');

            Swal.fire({
              type: 'success',
              title: data.title,
              text: data.message,
            });
          } else {
            Swal.fire({
              type: 'error',
              title: data.title,
              text: data.message,
            });
          }
        },
      });
    });
  },

  init() {
    recaptchaUpdater('login');
    _this.bindActions();
  },
};

const s = appAccessCode.settings,
  _this = appAccessCode;

export default _this;
